import "./App.css";

function App() {
  return <div className="App">Riley's Website</div>;
}

export default App;
